import moment from 'moment';

const NOTTags = (doc, data, clinica, typeDocumentInvoice) => {
    var NOT = doc.createElement("NOT");

    var NOT_1 = doc.createElement("NOT_1");
    NOT_1.innerHTML = data.nota;
    NOT.appendChild(NOT_1);

    return NOT;
}
export default NOTTags;